import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: '#08080d', color: '#7878a0', fontSize: 14
      }}>
        Loading…
      </div>
    );
  }

  return user ? children : <Navigate to="/admin/login" replace />;
}
